<div class="switchuser">
  @if (failed()) {
    <p class="switchuser__message switchuser__message--error">
      {{ 'IMPERSONATION.LINK_INVALID' | translate }}
    </p>
  } @else {
    <p class="switchuser__message">
      {{ 'IMPERSONATION.OPENING' | translate }}
    </p>
  }
</div>
